;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Celebrity = Backbone.Model.extend({
		api_prefix: '',

		url: function() {
			return this.api_prefix + '_celebrity/' + this.methodUrl;
		},

		isNew: function() {
			return true;
		},

		clone: function() {
			this.setApiUrl('clone')
				.save({ team_id: this.get('team_id') }, {
					ajaxSync: true,
					success: function(model, resp) {
						//TODO:
					}
				});

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));